import makeCrud from '@/store/site/localization/crud'

// Depolar (warehouse | store | virtual) — tam CRUD.
export default makeCrud('ecommerce_stock_warehouse')
